import  {  useMemo, } from "react";

import { PortMap } from "./PortMap";
import "./App.css";


function App() {
  let selectedSpy = useMemo(() => Math.floor(Math.random() * 9), []);


  return (
    <div className="App">
      <header />
      <img src={`./spies/${selectedSpy}.gif`} className="App-logo" alt="logo" />
      <div style={{ padding: 15 }}>
        <div className="boxed marginAuto somePadding">
          <div style={{ fontWeight: "bold", marginBottom: 2 }}>
            KratomLair.net
          </div>

        </div>
        <div className="bodytext boxed somePadding">
          <PortMap />
        </div>
      </div>
    </div>
  );
}

export default App;

